module.exports = __webpack_public_path__ + "static/media/entry.54aab33e.jpg";